var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"width":_vm.width,"src":require("../../assets/pasha.gif"),"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }